module.exports = __webpack_public_path__ + "static/about-bg-9f7cf9e46c3006d18a1e7f27203e4654.jpeg";